export default __webpack_public_path__ + "static/media/1828.10cb844a.png";